// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z9HX","type":"styles_type__3kkMe","choices":"styles_choices__Qi8LU"};